module.exports = require('react-router');
module.exports.routerRedux = require('react-router-redux');



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_dva@1.2.1@dva/router.js
// module id = 287
// module chunks = 0